/**
 * @generated SignedSource<<00bfdfd4716d3635086cd102db612269>>
 * @relayHash 081ae02dbc9e7d3009e7fbdca4492722
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7e0de08a75b889e79cd9fefc7277283b171871d0347b99f590cc073558ab0ab9

import type { ConcreteRequest } from 'relay-runtime';
export type JiraApplicationKey = "JIRA_CORE" | "JIRA_CUSTOMER_SERVICE" | "JIRA_PRODUCT_DISCOVERY" | "JIRA_SERVICE_DESK" | "JIRA_SOFTWARE" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type standardAddPaymentModalQuery$variables = {
  chargeElement: string;
  cloudId: string;
  hamsProductKey: string;
  isConfluence: boolean;
  isJira: boolean;
  jiraApplicationKey: JiraApplicationKey;
  projectType: JiraProjectType;
};
export type standardAddPaymentModalQuery$data = {
  readonly confluence_searchUser?: {
    readonly nodes: ReadonlyArray<{
      readonly confluencePerson: {
        readonly accountId: string | null | undefined;
        readonly displayName: string | null | undefined;
        readonly profilePicture: {
          readonly path: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly confluence_storage?: {
    readonly bytesLimit: AGG$Long | null | undefined;
    readonly bytesUsed: AGG$Long;
    readonly isUnlimited: boolean | null | undefined;
  } | null | undefined;
  readonly jira?: {
    readonly allJiraProjects: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly assignableUsers: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly accountId: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly attachmentStorageAllowed: AGG$Long | null | undefined;
    readonly attachmentStorageIsUnlimited: boolean | null | undefined;
    readonly attachmentStorageUsed: AGG$Long | null | undefined;
  } | null | undefined;
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly latestUsageForChargeElement: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type standardAddPaymentModalQuery = {
  response: standardAddPaymentModalQuery$data;
  variables: standardAddPaymentModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chargeElement"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hamsProductKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isConfluence"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJira"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraApplicationKey"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectType"
},
v7 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v8 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "hamsProductKey"
  }
],
v9 = {
  "args": [
    {
      "kind": "Variable",
      "name": "chargeElement",
      "variableName": "chargeElement"
    }
  ],
  "kind": "ScalarField",
  "name": "latestUsageForChargeElement"
},
v10 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v11 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v12 = {
  "condition": "isConfluence",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        (v10/*: any*/),
        {
          "kind": "Literal",
          "name": "cql",
          "value": "type=user"
        },
        {
          "kind": "Literal",
          "name": "excludeServiceAppUsers",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "ConfluenceSearchConnection",
      "kind": "LinkedField",
      "name": "confluence_searchUser",
      "plural": false,
      "selections": [
        {
          "concreteType": "ConfluenceSearchResponse",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "concreteType": "ConfluencePerson",
              "kind": "LinkedField",
              "name": "confluencePerson",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "displayName"
                },
                {
                  "concreteType": "Icon",
                  "kind": "LinkedField",
                  "name": "profilePicture",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "path"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "concreteType": "ConfluenceStorage",
      "kind": "LinkedField",
      "name": "confluence_storage",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isUnlimited"
        },
        {
          "kind": "ScalarField",
          "name": "bytesUsed"
        },
        {
          "kind": "ScalarField",
          "name": "bytesLimit"
        }
      ]
    }
  ]
},
v13 = [
  {
    "kind": "Variable",
    "name": "applicationKey",
    "variableName": "jiraApplicationKey"
  },
  (v10/*: any*/)
],
v14 = {
  "args": (v13/*: any*/),
  "kind": "ScalarField",
  "name": "attachmentStorageAllowed"
},
v15 = {
  "args": (v13/*: any*/),
  "kind": "ScalarField",
  "name": "attachmentStorageUsed"
},
v16 = {
  "args": (v13/*: any*/),
  "kind": "ScalarField",
  "name": "attachmentStorageIsUnlimited"
},
v17 = [
  (v10/*: any*/),
  {
    "fields": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "types.0",
            "variableName": "projectType"
          }
        ],
        "kind": "ListValue",
        "name": "types"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v18 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v19 = {
  "kind": "ScalarField",
  "name": "picture"
},
v20 = {
  "kind": "ScalarField",
  "name": "name"
},
v21 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v22 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "standardAddPaymentModalQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v8/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      (v12/*: any*/),
      {
        "condition": "isJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "args": (v17/*: any*/),
                "concreteType": "JiraProjectConnection",
                "kind": "LinkedField",
                "name": "allJiraProjects",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": (v18/*: any*/),
                            "concreteType": "JiraAssignableUsersConnection",
                            "kind": "LinkedField",
                            "name": "assignableUsers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraAssignableUsersEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v19/*: any*/),
                                      (v20/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "assignableUsers(first:10)"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "standardAddPaymentModalQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v8/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v9/*: any*/),
                  (v22/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      (v12/*: any*/),
      {
        "condition": "isJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "args": (v17/*: any*/),
                "concreteType": "JiraProjectConnection",
                "kind": "LinkedField",
                "name": "allJiraProjects",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": (v18/*: any*/),
                            "concreteType": "JiraAssignableUsersConnection",
                            "kind": "LinkedField",
                            "name": "assignableUsers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraAssignableUsersEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v21/*: any*/),
                                      (v11/*: any*/),
                                      (v19/*: any*/),
                                      (v20/*: any*/),
                                      (v22/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "assignableUsers(first:10)"
                          },
                          (v22/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7e0de08a75b889e79cd9fefc7277283b171871d0347b99f590cc073558ab0ab9",
    "metadata": {},
    "name": "standardAddPaymentModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1a2deb9f2ae9b251077ad9a1cce4e589";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
